import cookies from "../client/cookies";

class CurrencySelector {
  constructor(DOMelement, list) {
     try {
      this.el = DOMelement;
      this.list = list;
      this.cookies = cookies;
      
      [...list].forEach((li) =>
      li.addEventListener("click", (event) => {
        event.preventDefault();
        this.changeCurrency(li);
      })
    );
  } catch (error) {
      console.log(error);
    }
  }

  changeCurrency = (li) => {
      let dataGeoValue = li.firstElementChild.getAttribute("data-geo");
      this.cookies.update("LTG_GeoData", dataGeoValue);
      window.location.reload();
    }
}
export default CurrencySelector;